/** לאחר login / ‎/me‎ — שדות שם אחידים ב-localStorage וב-state */
export function normalizeUserRecord(u) {
  if (!u || typeof u !== "object") return u;
  const name = (u.fullName || u.full_name || "").trim();
  if (!name) return { ...u };
  return { ...u, fullName: name, full_name: name };
}

/**
 * שם פרטי לברכה — תומך ב־fullName / full_name (Mongo/API), ונפילה למזהה מטלפון אם אין שם.
 */
export function getFirstNameForGreeting(user) {
  if (!user || typeof user !== "object") return "";
  const raw = user.fullName || user.full_name;
  if (raw != null && String(raw).trim()) {
    return String(raw).trim().split(/\s+/)[0];
  }
  const digits = user.phone != null ? String(user.phone).replace(/\D/g, "") : "";
  if (digits.length >= 4) return digits.slice(-4);
  return "";
}

/** שם מלא לתפריט צד / כותרת — לאותם שדות + טלפון כמזהה אחרון */
export function getMenuUserLabel(user) {
  if (!user || typeof user !== "object") return "שלום אורח";
  const full = user.fullName || user.full_name;
  if (full != null && String(full).trim()) return String(full).trim();
  const digits = user.phone != null ? String(user.phone).replace(/\D/g, "") : "";
  if (digits.length >= 4) return `משתמש ···${digits.slice(-4)}`;
  return "שלום אורח";
}
